import React from "react";

const TextInput = ({id, name, addEstate, shortName, error, disabled, value, onChange, isHomePage}: any) => {
    return (
        <div className="mb-3">
            {(!isHomePage && !addEstate) &&
              <label htmlFor={id} className="form-label">{name}</label>
            }
            {addEstate &&
                <label htmlFor={id} className="form-label">{name}</label>
            }
            <input
                type="text"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                placeholder={shortName}
                id={id}
                name={id}
                value={value}
                onChange={onChange}
                disabled={disabled}
            />
            {error && <div className="text-danger">{error.join(' ')}</div>}
        </div>
    );
}
export default TextInput;
